import dayjs from "dayjs";

/**
 * Checks if the minimum lead time requirement is met
 * @param minimumLeadTimeInMinutes - The minimum lead time required in minutes
 * @param scheduledTime - Optional scheduled time object with day and time
 * @returns true if the time difference is less than the minimum lead time (warning needed), false if no scheduled time
 */
export const isUnderMinimumLeadTime = (
  minimumLeadTimeInMinutes: number,
  scheduledTime?: { day: string; time: string },
): boolean => {
  const now = dayjs();

  const targetTime = scheduledTime
    ? dayjs(`${scheduledTime.day}T${scheduledTime.time}`)
    : now;

  if (!targetTime.isValid()) throw new Error("Invalid scheduled time");

  const differenceInMinutes = targetTime.diff(now, "minute");

  return differenceInMinutes < minimumLeadTimeInMinutes;
};
